export const advancement: string[] = [
    "Level 1: 0 exp, +2 proficiency",
    "Level 2: 300 exp, +2 proficiency",
    "Level 3: 900 exp, +2 proficiency",
    "Level 4: 2,700 exp, +2 proficiency",
    "Level 5: 6,500 exp, +3 proficiency",
    "Level 6: 14,000 exp, +3 proficiency",
    "Level 7: 23,000 exp, +3 proficiency",
    "Level 8: 34,000 exp, +3 proficiency",
    "Level 9: 48,000 exp, +4 proficiency",
    "Level 10: 64,000 exp, +4 proficiency",
    "Level 11: 85,000 exp, +4 proficiency",
    "Level 12: 100,000 exp, +4 proficiency",
    "Level 13: 120,000 exp, +5 proficiency",
    "Level 14: 140,000 exp, +5 proficiency",
    "Level 15: 165,000 exp, +5 proficiency",
    "Level 16: 195,000 exp, +5 proficiency",
    "Level 17: 225,000 exp, +6 proficiency",
    "Level 18: 265,000 exp, +6 proficiency",
    "Level 19: 305,000 exp, +6 proficiency",
    "Level 20: 355,000 exp, +6 proficiency",
]

export const spellAtt: string[] = [
    "Bard: Charisma",
    "Cleric: Wisdom, prepared",
    "Druid: Wisdom, prepared",
    "Paladin: Charisma, prepared",
    "Ranger: Wisdom",
    "Sorcerer: Charisma",
    "Warlock: Charisma",
    "Wizard: Intelligence, prepared",
    "Artificier: Intelligence",
]

export const multiclassingReq: string[] = [
    "Barbarian: 13 Strength",
    "Bard: 13 Charisma",
    "Cleric: 13 Wisdom",
    "Druid: 13 Wisdom",
    "Fighter: 13 Strength or Dexterity",
    "Monk: 13 Dexterity or Wisdom",
    "Paladin: 13 Stength or Charisma",
    "Ranger: 13 Dexterity or Wisdom",
    "Rogue: 13 Dexterity",
    "Sorcerer: 13 Charisma",
    "Warlock: 13 Charisma",
    "Wizard: 13 Intelligence",
    "Artificier: 13 Intelligence",
]

export const spellSlots: { classes: string[], slots: number[][]}[] = [
    {
        classes: ["Bard", "Cleric", "Druid", "Sorcerer", "Wizard"],
        slots: [
            [1,1],
            [1],
            [1,2,2],
            [2],
            [3,3],
            [3],
            [4],
            [4],
            [4,5],
            [5],
            [6],
            [],
            [7],
            [],
            [8],
            [],
            [9],
            [5],
            [6],
            [7]
        ]
    },
    {
        classes: ["Paladin", "Ranger"],
        slots: [
            [],
            [1,1],
            [1],
            [],
            [1,2,2],
            [],
            [2],
            [],
            [3,3],
            [],
            [3],
            [],
            [4],
            [],
            [4],
            [],
            [4,5],
            [],
            [5],
            []
        ]
    },
    {
        classes: ["Artificer"],
        slots: [
            [1,1],
            [],
            [1],
            [],
            [1,2,2],
            [],
            [2],
            [],
            [3,3],
            [],
            [3],
            [],
            [4],
            [],
            [4],
            [],
            [4,5],
            [],
            [5],
            []
        ]
    },
    {
        classes: ["Spellcaster multiclass"],
        slots: [
            [1,1],
            [1],
            [1,2,2],
            [2],
            [3,3],
            [3],
            [4],
            [4],
            [4,5],
            [5],
            [6],
            [],
            [7],
            [],
            [8],
            [],
            [9],
            [5],
            [6],
            [7]
        ]
    },
]